import { cssUtil } from "../../utils/cssUtil";
import { getBaseStyles } from "../commonStyles";


export function renderDropdownFieldWidget(context, widget, parent, override = null) {

    const device = widget?.properties?.desktop;
    if (!device) return;

    // Root container
    const container = context.document.createElement("div");
    container.classList.add("widget", "form_field_widget");
    const breakpoint = context.currentBreakpoint;

    const styles = {
        ...getBaseStyles(widget, breakpoint)
    };

    applyFieldStyles(styles, device);
    container.setAttribute("style", cssUtil.toStyleString(styles));
    container.setAttribute("data-widgetId", widget.uid);
    container.setAttribute("data-widgetType", widget.type);
    container.setAttribute("data-widgetParent", widget.parent);
    parent.appendChild(container);

    // Label
    const label = renderLabel(context, device);
    if (label) container.appendChild(label);

    // Input (visual dropdown)
    const input = renderInput(context, device);
    container.appendChild(input);

    return container;
}

function renderLabel(context, device) {
    const labelText = device.label;
    if (!labelText) return null;

    const el = context.document.createElement("div");
    el.innerHTML = labelText;

    const styles = {};
    applyLabelStyles(styles, device);

    el.setAttribute("style", cssUtil.toStyleString(styles));
    return el;
}

function renderInput(context, device) {
    const el = context.document.createElement("div");
    el.classList.add("input");

    if (device.placeholder) {
        el.innerHTML = device.placeholder;
    }

    const styles = {};
    applyInputStyles(styles, device);

    el.setAttribute("style", cssUtil.toStyleString(styles));
    return el;
}

function applyFieldStyles(styles, device) {
    const alignment = device.styles?.layout?.alignment;
    if (alignment) {
        styles["text-align"] = alignment;
    }
}

function applyLabelStyles(styles, device) {
    const layout = device.styles?.layout;
    const regular = device.styles?.regular;
    if (!layout || !regular) return;

    const alignment = layout.alignment;
    const fieldSpacing = layout.fieldSpacing;
    const labelPadding = layout.labelPadding;

    if (fieldSpacing) {
        styles["padding-bottom"] = `${fieldSpacing}px`;
    }

    if (labelPadding) {
        if (alignment === "left") {
            styles["padding-left"] = `${labelPadding}px`;
        } else if (alignment === "right") {
            styles["padding-right"] = `${labelPadding}px`;
        }
    }

    // Label color
    const colorProp = regular.label?.color;
    if (colorProp) {
        styles.color =
            colorProp.type === "gradient"
                ? cssUtil.getCssGradient(colorProp)
                : cssUtil.getCssColor(colorProp);
    }

    applyFontStyles(styles, regular.label);
}

function applyInputStyles(styles, device) {
    const layout = device.styles?.layout;
    const regular = device.styles?.regular;
    if (!layout || !regular) return;

    const alignment = layout.alignment;
    const inputPadding = layout.inputPadding;

    if (inputPadding) {
        if (alignment === "left") {
            styles["padding-left"] = `${inputPadding}px`;
        } else if (alignment === "right") {
            styles["padding-right"] = `${inputPadding}px`;
        }
    }

    // Background
    const bg = regular.input?.background;
    if (bg) {
        styles.background =
            bg.type === "gradient"
                ? cssUtil.getCssGradient(bg)
                : cssUtil.getCssColor(bg);
    }

    // Placeholder color
    const colorProp = regular.input?.placeholderColor;
    if (colorProp) {
        styles.color =
            colorProp.type === "gradient"
                ? cssUtil.getCssGradient(colorProp)
                : cssUtil.getCssColor(colorProp);
    }

    applyFontStyles(styles, regular.input);
    applyBorderStyles(styles, regular.border);
}

function applyFontStyles(styles, fontStyle) {
    if (!fontStyle?.font) return;

    const font = fontStyle.font;

    if (font.fontFamily) styles["font-family"] = font.fontFamily;
    if (font.fontSize) styles["font-size"] = `${font.fontSize}px`;
    if (font.lineSpacing) styles["line-height"] = `${font.lineSpacing}em`;
    if (font.letterSpacing) styles["letter-spacing"] = `${font.letterSpacing}em`;
}

function applyBorderStyles(styles, border) {
    if (!border) return;

    if (border.radius) {
        if (border.radius.topLeft) styles["border-top-left-radius"] = `${border.radius.topLeft}px`;
        if (border.radius.topRight) styles["border-top-right-radius"] = `${border.radius.topRight}px`;
        if (border.radius.bottomRight) styles["border-bottom-right-radius"] = `${border.radius.bottomRight}px`;
        if (border.radius.bottomLeft) styles["border-bottom-left-radius"] = `${border.radius.bottomLeft}px`;
    }

    if (border.color) {
        styles["border-color"] =
            border.color.type === "gradient"
                ? cssUtil.getCssGradient(border.color)
                : cssUtil.getCssColor(border.color);
    }

    if (border.width) {
        if (border.style === "all") {
            styles["border-width"] = `${border.width}px`;
        } else {
            styles["border-bottom-width"] = `${border.width}px`;
        }

        const borderWidth = parseInt(border.width || 0, 10);
        const lineHeight = 37 - borderWidth;
        styles["line-height"] = `${lineHeight}px`;
    }
}